

























































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import { Surface } from '@/components/atoms';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import SpecialCoinIcon from '@/components/icons/SpecialCoin.vue';
import WelcomeCoinsIcon from '@/components/icons/WelcomeCoins.vue';
import SocialMediaIcon from '@/components/icons/SocialMedia.vue';

import eventBus from '@/utils/eventBus';

type Item = {
  link: string;
  icon: string;
  label: string;
  disabled?: boolean;
  disclaimer?: string;
};

@Component({
  components: {
    CloseModalIcon,
    SpecialCoinIcon,
    WelcomeCoinsIcon,
    SocialMediaIcon,
    Surface
  }
})
export default class StartMovingModal extends Vue {
  @Prop(String) title!: string;
  @Prop({ default: () => [] }) list!: Item[];

  created() {
    document.onkeydown = this.handleOnkeydown;
  }

  @Watch('$route')
  onRouteChange() {
    this.onClose();
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  handleOnkeydown({ key }: KeyboardEvent) {
    if (key === 'Escape') {
      this.onClose();
    }
  }

  handleItemClick(item: Item) {
    this.$analytics({
      eventCategory: 'Perfomance Overview',
      eventLabel: `Start creating data - ${item.label}`,
      eventAction: 'click'
    });
  }
}
